import React from "react";
import "./ThreeYearLLB.scss";

const FiveYearLLB = () => {
  return (
    <div className="llb-container">
      <h2 className="section-title">5-Year LL.B. Program</h2>
      <p className="intro">
        Integrated Course: The 5-year BA LLB (Bachelor of Arts + Bachelor of Laws) is an integrated undergraduate professional degree combining arts subjects (like Political Science, Sociology, Economics, History, English, etc.) with law subjects.
      </p>

      {/* Eligibility & Duration */}
      <div className="info-grid">
        <div className="info-card">
          <h4>Eligibility</h4>
          <ul>
            <li>Completion of 12th standard (PUC/10+2) with a minimum of 45%–50% marks </li>
          </ul>
        </div>
        <div className="info-card">
          <h4>Duration</h4>
          <ul>
            <li>5 years, divided into 10 semesters.</li>
            <li>Each semester blends law subjects with practical training.</li>
          </ul>
        </div>
      </div>

      {/* Curriculum */}
      <div className="curriculum">
        <h3>Curriculum Highlights</h3>
        <div className="curriculum-grid">
          <ul>
            <li>Arts Subjects: Political Science, History, Economics, Sociology, English.</li>
            <li>Law Subjects: Constitutional Law, Contract Law, Criminal Law, Family Law, Jurisprudence, Administrative Law, International Law, Corporate Law, etc.</li>
            <li>Practical Training: Moot courts, internships, legal aid camps, seminars.</li>
          </ul>
          <ul>
            <li>Advantage: Students can directly pursue law after 12th without doing a separate graduation and then LLB.</li>
            <li>Drafting, Pleading & Conveyancing</li>
          </ul>
        </div>
        {/* <p className="note">Includes internships, professional ethics, and Bar-Bench relations.</p> */}
      </div>

      {/* Unique Features */}
      {/* <div className="features">
        <h3>Unique Features at Bengaluru Law College</h3>
        <ul>
          <li>Guidance by experienced faculty and legal practitioners.</li>
          <li>Seminars, workshops & guest lectures by judges, lawyers, and academicians.</li>
          <li>Opportunities for legal aid camps, court visits, and internships.</li>
          <li>Student participation in <b>Tarang</b> (cultural) & <b>Khel</b> (sports) events.</li>
          <li>Focus on discipline, ethics, and holistic growth.</li>
        </ul>
      </div> */}

      {/* Careers */}
      <div className="careers">
        <h3>Career Opportunities</h3>
        <div className="career-cards">
          <div className="career-card">Strong legal drafting & research ability.</div>
          <div className="career-card">Good communication & argumentation skills.</div>
          <div className="career-card">Knowledge of current laws, amendments, and legal technology (AI, e-discovery, legal databases).</div>
          <div className="career-card">Networking & internships with reputed lawyers, judges, and firms.</div>
        </div>
      </div>

      {/* Job Opportunities */}
      <section className="llb-section">
        <h2 className="section-title">Job Opportunities after 5-Year LL.B.</h2>
        <p>
          A 5-Year LL.B. degree opens diverse and rewarding career paths in both
          public and private sectors. Graduates are equipped with legal knowledge,
          advocacy skills, and ethics to pursue roles such as:
        </p>

        <h3>Litigation and Practice</h3>
        <p>
          Work under senior advocates and gradually start independent practice.

Appear before District Courts, High Courts, and Supreme Court (after proper registration with the State Bar Council).
        </p>

        <h3>Corporate & Business Sector</h3>
        <p>
          Legal Advisors, In-house Counsels, Compliance Officers in MNCs, Banks, Finance Companies, IT Companies, Startups, etc.

Corporate law, mergers, acquisitions, contracts, and intellectual property law are in high demand.
        </p>

        <h3>Law Firms</h3>
        <p>
          Join national or international law firms as an Associate.

Work involves corporate law, taxation, arbitration, mergers & acquisitions, IPR, etc.
        </p>

        <h3>Judiciary</h3>
        <p>
          Eligible to write Judicial Services Examination (Civil Judge, Judicial Magistrate, etc.).

After experience, can become a District Judge, High Court Judge, or Supreme Court Judge.
        </p>

        <h3>Government Sector</h3>
        <p>
          Opportunities in Public Prosecutor’s office, Legal Advisor to Government Departments, Law Officers in PSUs (ONGC, BHEL, LIC, etc.).
        </p>

        <h3>Higher Education & Research</h3>
        <p>
          Pursue LLM (Master of Laws) in India or abroad.

Later can go for PhD in Law and become a Professor/Lecturer in law colleges and universities.
        </p>

        <h3>Civil Services</h3>
        <p>Many BA LLB graduates prepare for UPSC, State Public Service Commission Exams (IAS, IPS, DySP, etc.).

Legal background gives an added advantage in these exams.</p>

<h3>Alternative Careers</h3>
<p>Legal Journalism, Legal Process Outsourcing (LPO), Human Rights NGOs, Policy Advocacy, International Organizations (UN, WHO, ILO), and Arbitration/Mediation specialists.</p>
      </section>
    </div>
  );
};

export default FiveYearLLB;


// import React from "react";
// import "./ThreeYearLLB.scss";

// const ThreeYearLLB = () => {
//   return (
//     <div className="llb-container">
//       {/* Program Details */}
//       <section className="llb-section">
//         <h2>3-Year LL.B. Program</h2>
//         <p>
//           The 3-Year Bachelor of Laws (LL.B.) program at <b>Bengaluru Law College</b> is
//           designed for graduates who aspire to pursue a career in the field of law.
//           This professional program offers a strong foundation in legal principles,
//           practical skills, and ethical values, preparing students to become competent
//           advocates, legal advisors, academicians, or judicial officers.
//         </p>

//         <h3>Eligibility</h3>
//         <ul>
//           <li>Bachelor’s Degree in any discipline from a recognized university.</li>
//           <li>Admission based on merit as per BCI & KSLU norms.</li>
//         </ul>

//         <h3>Duration</h3>
//         <p>3 Academic Years divided into 6 Semesters.</p>
//         <p>Each semester blends core law subjects with skill-based and practical training.</p>

//         <h3>Curriculum Highlights</h3>
//         <ul>
//           <li>Constitutional Law</li>
//           <li>Law of Crimes (IPC & CrPC)</li>
//           <li>Contract and Company Law</li>
//           <li>Property and Labour Laws</li>
//           <li>Family Law</li>
//           <li>Public International Law & Human Rights</li>
//           <li>Administrative and Environmental Law</li>
//           <li>Civil Procedure Code & Law of Evidence</li>
//         </ul>

//         <h4>Practical Components</h4>
//         <ul>
//           <li>Moot Court Exercises</li>
//           <li>Drafting, Pleading, and Conveyancing</li>
//           <li>Professional Ethics and Bar-Bench Relations</li>
//           <li>Internships with advocates, law firms, NGOs, and corporates</li>
//         </ul>

//         <h3>Unique Features</h3>
//         <ul>
//           <li>Experienced faculty and legal practitioners</li>
//           <li>Seminars, workshops, and guest lectures</li>
//           <li>Legal aid camps, court visits, and internships</li>
//           <li>Student engagement in <b>Tarang</b> (cultural) & <b>Khel</b> (sports)</li>
//           <li>Focus on discipline, ethics, and values</li>
//         </ul>
//       </section>

//       {/* Job Opportunities */}
//       <section className="llb-section">
//         <h2>Job Opportunities after 3-Year LL.B.</h2>
//         <p>
//           A 3-Year LL.B. degree opens diverse and rewarding career paths in both
//           public and private sectors. Graduates are equipped with legal knowledge,
//           advocacy skills, and ethics to pursue roles such as:
//         </p>

//         <h3>1. Litigation and Practice</h3>
//         <p>
//           Enroll as an Advocate with the State Bar Council and practice in District,
//           High Courts, and Supreme Court. Specialize in Criminal Law, Civil Law,
//           Corporate Law, Family Law, Taxation, or Constitutional Law.
//         </p>

//         <h3>2. Judiciary</h3>
//         <p>
//           Appear for Judicial Service Examinations to become Judicial Magistrates,
//           District Judges, or Civil Judges.
//         </p>

//         <h3>3. Corporate & Business Sector</h3>
//         <p>
//           Work as Legal Advisors, Corporate Lawyers, or Compliance Officers in MNCs,
//           banks, insurance firms, and startups.
//         </p>

//         <h3>4. Government & Public Sector</h3>
//         <p>
//           Opportunities in Public Prosecutor’s Office, Government Legal Cells, PSUs,
//           Defence Services (JAG), and Banks.
//         </p>

//         <h3>5. Academics & Research</h3>
//         <p>
//           Pursue LL.M. and Ph.D. for teaching, research, and academic leadership.
//         </p>

//         <h3>6. Alternative Careers</h3>
//         <p>
//           Work with NGOs, International Organizations, Human Rights Bodies,
//           Build a career in Legal Journalism, Policy Making, or Legal Process Outsourcing (LPOs)
//           , or Join Civil Services (IAS, IPS, IFS, KAS, etc.) with law as a strong foundation.
//         </p>
//       </section>
//     </div>
//   );
// };

// export default ThreeYearLLB;
